import { Box, Button, Grid, Typography } from "@mui/material";
import LineGradient from "src/features/common/graph/line-gradient";
import { BarChart } from "src/features/common/graph/bar-chart";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface TrendData {
  chartType: string;
  yMax?: number;
  dataPointsY1?: number[];
  dataPointsY2?: number[];
  trendsName: string;
  speedName?: string;
  datapoints?: number[];
  labels?: string[];
  yLabel?: string;
  isGradientOpposite?: boolean;
}

interface TrendsProps {
  trends: TrendData[];
  fullScreen: boolean;
}

export default function Trends({ trends, fullScreen }: TrendsProps) {
  const navigate = useNavigate();
  const [trendsData, setTrendsData] = useState<TrendData[]>(trends);

  function convertToLocalTime(label: string): string {
    const [monthDay, time] = label.split(", ");
    const [month, day] = monthDay.split(" ");
    const [hour, minute] = time.split(":");

    // Create a Date object assuming the input is in UTC
    const date = new Date(
      Date.UTC(
        new Date().getFullYear(),
        new Date(Date.parse(month + " 1, 2024")).getMonth(),
        parseInt(day),
        parseInt(hour),
        parseInt(minute)
      )
    );

    // Convert to local time
    const options: Intl.DateTimeFormatOptions = {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hourCycle: "h23", // Use 24-hour format
    };
    return date.toLocaleString("en-US", options); // Returns the local time formatted as "Aug 23, 9:55"
  }

  useEffect(() => {
    if (!fullScreen) {
      setTrendsData(() => trends.filter((v) => v.chartType === "LineGradient"));
    } else {
      console.log("Rohittrends" + trends)
      setTrendsData(trends);
    }
  }, [fullScreen, trends]);

  return (
    <>
      <Grid container spacing={2} sx={{ overflow: "auto" }}>
        {trendsData &&
          trendsData.map((val) => (
            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              key={`trends${val?.trendsName.replace(" ", "_")}`}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <Typography
                variant="body1"
                component={"span"}
                textAlign={"center"}
              >
                {val?.trendsName}
              </Typography>
              <Box
                sx={{
                  height: fullScreen ? "50vh" : "30vh",
                  width: "100%",
                }}
              >
                {val?.chartType === "LineGradient" && (
                  <LineGradient
                    maxValue={val?.yMax}
                    dataPointsY1={val?.dataPointsY1}
                    dataPointsY2={val?.dataPointsY2}
                    trendsName={val?.trendsName}
                    hideBackground={true}
                    speedName={val.speedName}
                    datapoints={val?.datapoints}
                    labels={val?.labels?.map((label) =>
                      convertToLocalTime(label)
                    )}
                    yLabel={val.yLabel}
                    isGradientOpposite={val?.isGradientOpposite}
                  />
                )}
                {val?.chartType === "bar" && (
                  <BarChart
                    datapoints={val?.datapoints}
                    labels={val?.labels}
                    maxValue={val?.yMax}
                  />
                )}
              </Box>
            </Grid>
          ))}
        {trendsData.length === 0 && (
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <Typography textAlign={"center"} sx={{ width: "100%" }}>
              No Trend Data found
            </Typography>
          </Grid>
        )}
      </Grid>
      {fullScreen && (
        <Box sx={{ display: "flex" }}>
          <Typography p={"10px 20px"} color={"red"}>
            Note :- To know more about other indicators, go to Trends Page
          </Typography>
          <Button
            onClick={() => navigate("/trends")}
            size="small"
            variant="contained"
            sx={{ mt: "10px" }}
          >
            Click here
          </Button>
        </Box>
      )}
    </>
  );
}
